/**
 * @file events of waterfall chart is equal to column chart
 */
export { EVENT_MAP, onEvent } from '../column/event';
